module.exports = __webpack_public_path__ + "5c114213/img/settings-ico.a214628d.svg";